export default "__VITE_ASSET__DYpJBwXy__"